import React from 'react';
import animeCharacter from "../../assets/images/anime-character.png";
import beachBackground from "../../assets/images/beach-background.png";

const SplashScreen = ({ onStartGame }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="relative bg-cover bg-center bg-no-repeat max-w-[480px] w-full h-svh flex flex-col items-center justify-between overflow-hidden"
        style={{ 
          backgroundImage: `url(${beachBackground})`,
          backgroundSize: 'cover'
        }}
      >
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/80 to-transparent" />

        {/* Content */}
        <div className="relative z-10 w-full flex flex-col items-center justify-between h-full py-12 px-8">
          {/* Title Section */}
          <div className="text-center">
            <h2 className="text-xl font-normal mb-4">
              序章：比嘉さんからの依頼
            </h2>
            <div className="bg-white/90 rounded-lg p-6 max-w-[90%] mx-auto">
              <p className="text-sm leading-relaxed">
                沖縄のリゾート地に訪れたあなたたちは、観光案内所で観光アンバサダー比嘉さんと出会う。沖縄に何度か訪れたことのある私は、気づいたら青い海の隣になっていた。
              </p>
              <p className="text-sm leading-relaxed mt-4">
                落ち着いた夕焼けを眺めながら、耳元で囁くようなささやきがあった。
              </p>
              <p className="text-sm leading-relaxed mt-4 text-blue-600 font-medium">
                「君は青い海の秘密を見つけられるかな？」
              </p>
              <p className="text-sm leading-relaxed mt-4">
                こうして、あなたたちは比嘉さんと共に、沖縄の自然や文化を巡りながら「青い海の秘密」を探す冒険へと旅立つ。
              </p>
            </div>
          </div>

          {/* Start Button */}
          <button
            onClick={onStartGame}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-12 rounded-full shadow-lg text-lg transform transition-all duration-200 hover:scale-105 active:scale-95"
          >
            次へすすむ
          </button>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;